<template>
    <div class="heading">
        <h2>{{text}}</h2>
        <span class="heading-subtitle" v-if="sub">{{sub}}</span>
    </div>
</template>

<script>
    export default {
        props: [
            'text',
            'sub'
        ],
        name: "Heading"
    }
</script>

<style scoped lang="stylus">
    .heading
        margin-bottom 27px
        h2
            font-size 3.6rem
            line-height 4.6rem
            margin 4rem 0 0 0
        .heading-subtitle
            font-family: "VWAGTheSansRegular",Arial,sans-serif;
            line-height: 32px
            font-size: 24px
            color #4c5356
</style>